import React, { useState } from 'react'
import { Outlet , Navigate } from 'react-router-dom'
import {useAuth} from "../../../usercontext";
import StudentHeader from "../header";
import Footer from "../../footer";
import StudentSideBar from "../sidebar";

export default function Student911Layout() {
  const [mobileMenu, setMobileMenu] = useState(false)
    const { profile } = useAuth();

   // let {user} = JSON.parse(localStorage.getItem("eplus"));

//console.log("Layout",profile);

      if(!profile || profile.role !== "Student911")
    return <Navigate to={"/login"} />

  return (
    <div className='main-wrapper'>
      <StudentHeader
        activeMenu={'Profile'}
        setMobileMenu={setMobileMenu}
        mobileMenu={mobileMenu}
      />
      {/* Student Dashboard */}
      <div className='page-content2 mx-5'>
        <div className='px-3'>
          <div className='row'>
            {/* Sidebar */}
            <StudentSideBar
              activeMenu={'BookList'}
              setMobileMenu={setMobileMenu}
              mobileMenu={mobileMenu}
            />
            {/* Sidebar */}
            <Outlet />
          </div>
        </div>
      </div>
      {/* Student Dashboard */}
      <Footer />
    </div>
  )
}
